module.exports = __webpack_public_path__ + "img/marketing-cloud-logo.90fd8759.svg";